<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">Package Configuration</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for=""
                >Helper Amount <span>( <i class="fa fa-inr"></i> )</span> :
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="helpersBasicAmount"
                class="form-control"
                placeholder="Helper Amount"
              />
            </div>
            <div class="col-md-4">
              <label for=""
                >Helper GST (<span class="font-weight-B">%</span>):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="helperGST"
                class="form-control"
                placeholder="Helper GST"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for=""
                >Coupon Basic Amount <span>( <i class="fa fa-inr"></i> )</span>:
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="couponBasicAmount"
                class="form-control"
                placeholder="Coupon Basic Amount"
              />
            </div>
            <div class="col-md-4">
              <label for=""
                >Trip Fare GST (<span class="font-weight-B">%</span>):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="tripFareGST"
                class="form-control"
                placeholder="Trip Fare GST"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for=""
                >Commission Fee <span>( <i class="fa fa-inr"></i> )</span>:
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="commissionFee"
                placeholder="Commission Fee"
                class="form-control"
              />
            </div>
            <div class="col-md-4">
              <label for=""
                >Commission Fee GST (<span class="font-weight-B">%</span>):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="commissionFeeGST"
                class="form-control"
                placeholder="Commission Fee GST"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for=""
                >Convenience Fee <span>( <i class="fa fa-inr"></i> )</span>:
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="convenienceFee"
                placeholder="Convenience Fee"
                class="form-control"
              />
            </div>
            <div class="col-md-4">
              <label for=""
                >Convenience Fee GST (<span class="font-weight-B">%</span>):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="convenienceFeeGST"
                class="form-control"
                placeholder="Commission Fee GST"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for=""
                >Minimum Distance For Trip (
                <span class="font-weight-B">KM</span> ):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="minimumDistanceForTrip"
                placeholder="Minimum Distance For Trip (KM)"
                class="form-control"
              />
            </div>
            <div class="col-md-4">
              <label for=""
                >Helper TDS (<span class="font-weight-B">%</span>):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="helperTDS"
                class="form-control"
                placeholder="Helper TDS"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for=""
                >Distance for Notification ( <span class="font-weight-B">KM</span> ):
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="distanceForNotification"
                class="form-control"
                placeholder="Distance for Notification (KM)"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row mt-3 mb-3 text-center">
            <div class="col-md-12">
              <button
                (click)="packageConfiguration()"
                class="btn btn-primary btn-lg btn-block"
                [disabled]="
                helpersBasicAmount === null || helpersBasicAmount === undefined ||
                helperTDS === null || helperTDS === undefined ||
                helperGST === null || helperGST === undefined ||
                couponBasicAmount === null || couponBasicAmount === undefined ||
                tripFareGST === null || tripFareGST === undefined ||
                commissionFee === null || commissionFee === undefined ||
                commissionFeeGST === null || commissionFeeGST === undefined ||
                convenienceFee === null || convenienceFee === undefined ||
                convenienceFeeGST === null || convenienceFeeGST === undefined ||
                minimumDistanceForTrip === null || minimumDistanceForTrip === undefined ||
                distanceForNotification === null || distanceForNotification === undefined
              ">
              
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

              
